// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
    getPlafonPerobatan,
    insertPlafonPerobatan,
    plafonPerobatanSelector,
    updatePlafonPerobatan
} from "./plafonPerobatanSlice";

import {Colors} from "../../../assets/Colors";

const PlafonPerobatanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const plafonPerobatan = useSelector(plafonPerobatanSelector);

    useEffect(() => {
        dispatch(
            getPlafonPerobatan({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && plafonPerobatan?.isGetSuccess && !plafonPerobatan.isGetFetching) {
            let calc = plafonPerobatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            let tempMaxPage = plafonPerobatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (search === "" && plafonPerobatan?.isGetSuccess && !plafonPerobatan.isGetFetching) {
            let calc = plafonPerobatan?.count - 1;

            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            setSearchFetch(false);
            setMaxPage(Math.ceil(calc / count));
        }

        if (
            !plafonPerobatan?.isGetFetching &&
            plafonPerobatan?.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = plafonPerobatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            setMaxPage(Math.ceil(calc / count));
            setFirstLoading(true);
            dispatch(
                getPlafonPerobatan({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            alertService.success(plafonPerobatan.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getPlafonPerobatan({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (updateFetch) {
            setUpdateFetch(false);
            alertService.success(plafonPerobatan.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getPlafonPerobatan({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }
    });

    // function handleGetPlafonPerobatan(params) {
    //   return dispatch(getPlafonPerobatan(params));
    // }

    function handleInsertPlafonPerobatan(param) {
        setInsertFetch(true);
        const params = {
            namaPlafonPerobatan: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            nominalSatuTahun: param.inputNumberOneValue,

        };
        dispatch(insertPlafonPerobatan(params));
    }

    function handleUpdatePlafonPerobatan(param) {
        setUpdateFetch(true);

        const params = {
            setupPlafonPerobatanID: currentData.SetupPlafonPerobatanID,
            namaPlafonPerobatan: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            nominalSatuTahun: param.inputNumberOneValue,
            status: param.status,
        };
        dispatch(updatePlafonPerobatan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getPlafonPerobatan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getPlafonPerobatan(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = plafonPerobatan.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? plafonPerobatan.count : newCount,
            search: search,
        };
        dispatch(getPlafonPerobatan(params));

        setPage(1);
        setCount(newCount === "-1" ? plafonPerobatan.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="PlafonPerobatan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Plafon Perobatan"
                                tableData={plafonPerobatan.data}
                                colOneTitle="ID"
                                colOneData="SetupPlafonPerobatanID"
                                colTwoTitle="Jenis Plafon Perobatan"
                                colTwoData="NamaSetupPlafonPerobatan"
                                colThreeTitle="Golongan"
                                colThreeData="NamaGolongan"
                                colFourTitle="Tipe Karyawan"
                                colFourData="NamaTipeKaryawan"
                                colFiveTitle="Nominal Satu Tahun"
                                colFiveData="NominalSatuTahun"
                                status="Status"
                                fetching={plafonPerobatan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Plafon Perobatan"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        inputOneTitle="Nama Plafon Perobatan"
                        inputOnePlaceholder=""
                        inputNumberOneTitle="Nominal Satu Tahun"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertPlafonPerobatan}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SetupPlafonPerobatanID}
                        modal={handleModal}
                        modalTitle="Ubah Plafon Perobatan"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        dropdownGolonganValue={currentData.GolonganID}
                        dropdownTipeKaryawanValue={currentData.TipeKaryawanID}
                        inputOneTitle="Nama Plafon Perobatan"
                        inputOneValue={currentData.NamaSetupPlafonPerobatan}
                        inputNumberOneTitle="Nominal Satu Tahun"
                        inputNumberOneValue={currentData.NominalSatuTahun}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdatePlafonPerobatan}
                    />
                )}
            </div>
        );
    }
};

export default PlafonPerobatanPage;
